// Shared ISO 20022 postal address formatter — used by the asset detail
// compact display and the assets tree columns.

export function formatIso20022Address(address: Record<string, any>): string {
    if (address.addressLine?.length > 0) {
        return [...address.addressLine, address.country].filter(Boolean).join(', ')
    }
    // Defend against legacy data where geocoding stored the abbreviated
    // address ("111 Bd de Magenta") as buildingName: a real building name
    // never starts with the building number.
    const buildingName =
        address.buildingName &&
        !(address.buildingNumber && String(address.buildingName).trim().startsWith(String(address.buildingNumber)))
            ? address.buildingName
            : null
    const parts = [
        [address.buildingNumber, address.streetName].filter(Boolean).join(' '),
        buildingName,
        [address.postCode, address.townName].filter(Boolean).join(' '),
        address.countrySubDivision,
        address.country,
    ]
    return parts.filter(Boolean).join(', ')
}

/** One-line, tree-friendly address: street + town only, no region/country. */
export function formatIso20022AddressShort(address: Record<string, any>): string {
    if (address.addressLine?.length > 0) {
        return address.addressLine.filter(Boolean).join(', ')
    }
    const parts = [
        [address.buildingNumber, address.streetName].filter(Boolean).join(' '),
        [address.postCode, address.townName].filter(Boolean).join(' '),
    ]
    return parts.filter(Boolean).join(', ')
}
